import React from "react";
import CarouselSlider from "../Common/CarouselSlider";
import StatsCounter from "../Common/StatsCounter";
import ServicesSection from "../Common/ServicesSection";
import ProjectsSection from "../Common/ProjectsSection";
import CoursesSection from "../Common/CoursesSection";
import ContactSection from "../Common/ContactSection2";
import AboutSection from "../Common/AboutSection";
import TeamSection from "../Common/TeamSection";
import TestimonialCarousel from "../Common/TestimonialCarousel";
import StepsSection from "../Common/StepsSection";
import { coursesData } from "../../data/coursesData";
import { statsData } from "../../data/statsData";
import { PopupWidget } from "react-calendly";
import VideoTestimonials from "../Common/VideoTestimonials";

export default function Home() {
  // Step 1: Create an array of slide data
  const banners = [
    {
      id: 1,
      image: "https://res.cloudinary.com/dg0eeyvud/image/upload/v1768735889/banner-1_ofr4gw.webp", //"https://themewagon.github.io/HighTechIT/img/carousel-1.jpg",
      subtitle: "Dream. Study. Rise.",
      title: "Turn ambition into admission today.",
      description: "Your expert bridge to British education. We guide your entire journey from application to arrival.",
      btn1: { text: "Contact Us", link: "/contact" },
    },
    {
      id: 2,
      image: "https://res.cloudinary.com/dg0eeyvud/image/upload/v1768736358/banner-2_zvhllj.webp",
      subtitle: "Premium. For Free.",
      title: "Top-tier advice. Zero cost to you",
      description: "Expert university and visa guidance without the fees. We invest in your potential, not your wallet.",
      btn1: { text: "Contact Us", link: "/contact" },
    },
    {
      id: 3,
      image: "https://res.cloudinary.com/dg0eeyvud/image/upload/v1773858792/banner-3_t8ycdo.webp",
      subtitle: "Unlock the UK",
      title: "Global degrees, global careers.",
      description: "Complete support for visas, admissions, and career planning. Start your UK success story today.",
      btn1: { text: "Contact Us", link: "/contact" },
    },
    {
        id: 4,
        image: "https://res.cloudinary.com/dg0eeyvud/image/upload/v1769256461/banner-5_qxb5hg.webp",
        subtitle: "Your UK Launchpad",
        title: "Expert UK Advice at Zero Cost.",
        description: "Based in the UK, we know the system. Let our local experts guide your global journey today.",
        btn1: { text: "Contact Us", link: "/contact" },
      },
  ];

   const services = [
    {
      id: 1,
      icon: "fa fa-code",
      title: "Business & Finance",
      description:
        "Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt.",
      buttonText: "Read More",
    },
    {
      id: 2,
      icon: "fa fa-file-code",
      title: "Construction Management",
      description:
        "Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt.",
      buttonText: "Read More",
    },
    {
      id: 3,
      icon: "fa fa-external-link-alt",
      title: "Digital Technologies & Computing",
      description:
        "Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt.",
      buttonText: "Read More",
    },
    {
      id: 4,
      icon: "fas fa-user-secret",
      title: "Health & Social Care",
      description:
        "Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt.",
      buttonText: "Read More",
    },
    {
      id: 5,
      icon: "fa fa-envelope-open",
      title: "Project Management",
      description:
        "Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt.",
      buttonText: "Read More",
    },
    {
      id: 6,
      icon: "fas fa-laptop",
      title: "Psychology",
      description:
        "Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum. Aliquam dolor eget urna ultricies tincidunt.",
      buttonText: "Read More",
    },
  ];

  const steps = [
    {
      icon: "fas fa-calendar-alt",
      title: "Step 1: Book a Free Consultation",
      description: "Speak with our advisors to find the right course and check eligibility.",
    },
    {
      icon: "fas fa-comments",
      title: "Step 2: Interviews & Assessments",
      description: "We’ll prepare you for university interviews, with a 90% success rate.",
    },
    {
      icon: "fas fa-money-check-alt",
      title: "Step 3: Finance & Enrollment",
      description: "We assist with student finance and ensure access to funding.",
    },
    {
      icon: "fas fa-hands-helping",
      title: "Step 4: Ongoing Support",
      description: "From enrollment to graduation, we support you every step of the way.",
    },
  ];

   const teamMembers = [
    {
      name: "John Smith",
      designation: "CEO",
      image: "https://themewagon.github.io/HighTechIT/img/team-1.jpg",
      socials: {
        facebook: "#",
        twitter: "#",
        instagram: "#",
        linkedin: "#",
      },
    },
    {
      name: "Emily Johnson",
      designation: "Project Manager",
      image: "https://themewagon.github.io/HighTechIT/img/team-2.jpg",
      socials: {
        facebook: "#",
        twitter: "#",
        instagram: "#",
        linkedin: "#",
      },
    },
    {
      name: "Michael Lee",
      designation: "Lead Developer",
      image: "https://themewagon.github.io/HighTechIT/img/team-3.jpg",
      socials: {
        facebook: "#",
        twitter: "#",
        instagram: "#",
        linkedin: "#",
      },
    },
    {
      name: "Sophia Brown",
      designation: "UI/UX Designer",
      image: "https://themewagon.github.io/HighTechIT/img/team-4.jpg",
      socials: {
        facebook: "#",
        twitter: "#",
        instagram: "#",
        linkedin: "#",
      },
    },
  ];

  
  return (
	<div>
        <CarouselSlider slides={banners} carouselId="bannersCarousel" />

		 <StatsCounter stats={statsData} />
         <StepsSection
            title="Your Pathway to University Success – No Matter Your Background!"
            subtitle="How We Make It Happen"
            steps={steps}
         />
         <CoursesSection courses={coursesData}/>

         <VideoTestimonials />

         <TeamSection title="Meet Our Expert Team" subtitle="Our Team" teamMembers={teamMembers}/>


	   <ContactSection />   

       <div className="whatsapp-float">
         <a
          //  href="https://wa.me/+447514674496"
           href="https://api.whatsapp.com/send?phone=+447514674496&text=Hello%20Unigenius%2C%20I%20would%20like%20to%20know%20more%20about%20the%20courses."
           target="_blank"
           rel="noopener noreferrer"
         >
           <i className="fab fa-whatsapp"></i>
         </a>
       </div>

       <PopupWidget
        url="https://calendly.com/unigenius-uk/30min"
        rootElement={document.getElementById("root")}
        text="Claim Your Slot Now"
        textColor="#f8d99b"
        color="#002c6a"
        branding={false}
      />
	</div>
          );
}